import React, { Component } from "react";
import "./ConversationStyleSheet.css";
import PreviewAttachmentFiles from "./PreviewAttachmentFiles";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import uuid from "react-uuid";
import ConversationHeader from "./ConversationHeader";
import Conversation from "./Conversation";
import InputBox from "./InputBox";
import dayjs from "dayjs";
import xmppService from "../Services/XMPPService";
import HWLog from "../HWLibrary/HWLog";
import { MessageType } from "./MessageBoxTypes/Message";
import apiService from "../Services/APIService";
import { Snackbar } from "@material-ui/core";
import SendChatTranscriptForm from "./SendChatTranscriptForm";
import AlertDialog from "../CommonUtils/AlertDialog";
import homeImage from "../../images/home.svg";
import gifImage from "../../images/gif.svg";
import settingImage from "../../images/settings.svg";
import Popup from "./Popup";
import Setting from "./Setting";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Picker,{SKIN_TONE_DARK,SKIN_TONE_LIGHT, SKIN_TONE_MEDIUM_DARK,SKIN_TONE_NEUTRAL} from "emoji-picker-react";
import { Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import { Modal } from "react-modal-overlay";
import "react-modal-overlay/dist/index.css";
import Typography from "@mui/material/Typography";

class ConversationPage extends Component {
  constructor(props) {
    super(props);
    this.messageRef = React.createRef();
    this.file = React.createRef();
    this.state = {
      messages: [],
      xmppMessageHistory: [],
      previewFiles: [],
      isConversationClosed: false,
      isChatClose: false,
      showSnackBar: false,
      showSendChatTranscriptForm: false,
      showCloseDialog: false,
      isFetchingMessages: true,
      isReset: false,
      showEmoji: false,
      showGif: false,
      isLoading: false,
      isOnlyEmoji: false,
      showSetting: null,
      radioValue: "sendIt",
      finalValue: null,
    };
    if (this.props.config?.notification?.audio !== undefined) {
      this.audio = new Audio(this.props.config.notification.audio);
    }
    this.conversationRef = React.createRef();
    this.emojiRef = React.createRef();
  }
  defaultMessage = "Type a message...";

  render() {
    const open = this.state.showSetting;
    console.log(this.emojiRef)
    return (
      <div className="s360-conversation-page" style={this.conversationStyle()}>
        <ConversationHeader
          {...this.props}
          {...this.state}
          isActiveConversation={this.isActiveConversation}
          startNewConversation={this.startNewConversation}
          closeConversation={this.closeConversation}
          onSendChatTranscriptClick={this.onSendChatTranscriptClick}
          closeConversationClick={this.closeConversationClick}
        />
        <div
          className="s360-conversation-page-container"
          id="conver"
          style={this.containerStyle()}
        >
          <Conversation
            ref={this.conversationRef}
            onScrollToConversationTop={this.onScrollToConversationTop}
            {...this.props}
            {...this.state}
            actions={{ ...this.props.actions, ...this.actions }}
            startNewConversation={this.startNewConversation}
          />
        </div>
        <div>
          {this.state.showGif && (
            <Popup
              handleClose={this.handleClose}
              addMessagesToList={this.addMessagesToList}
              {...this.props}
            />
          )}
        </div>

        {this.isActiveConversation() && (
          <InputBox
            {...this.props}
            {...this.actions}
            finalValue={this.state.finalValue}
            setRef={this.messageRef}
            send={this.onMessageSend}
          />
        )}
        <div className="s360-conversation-page-footer-container">
          <div className="s360-conversation-page-footer-tool-container">
          {this.props.config.showReset ?<div
              className="s360-input-box-home"
              id="home"
              style={{ marginBottom: "0px" }}
              onClick={this.resetChat}
            >
             <Tooltip
                title={<Typography fontSize={12}>Reset chat</Typography>}
                s
              >
                <img
                  style={{
                    width: "21px",
                    height: "21px",
                    marginRight: "4px",
                    marginLeft: "4px",
                    cursor: "pointer",
                  }}
                  src={homeImage}
                  alt="/"
                ></img>
              </Tooltip> 
            </div>: null}
            <div
              className="s360-input-box-emoji"
              id="emoji"
              style={{ marginBottom: "0px" }}
              onClick={this.showEmoji}
            >
              {this.emojiSVGImage(
                this.props.config.designDetails.innerButtonSVGColor
              )}
            </div>
            <div>
              {this.state.showEmoji && (
                <Picker
               disableSkinTonePicker
                  onEmojiClick={this.onEmojiClick}
                  groupVisibility={{
                    flags: false,
                    animals_nature: false,
                    food_drink: false,
                    travel_places: false,
                    activities: false,
                    objects: false,
                    symbols: false,
                  }}
                  pickerStyle={{
                    position: "absolute",
                    top: "115px",
                    left: "9px",
                    width: "93%",
                    zIndex: "99999",
                  }}
                  ref={this.emojiRef}
                />
              )}
            </div>

            {this.props.config.showGif ?<div
              className="s360-input-box-gif"
              id="gif"
              style={{ marginBottom: "0px"}}
              onClick={this.showGIF}
            >
              <img
                style={{
                  width: "28px",
                  height: "28px",
                  marginRight: "48px",
                  marginLeft: "4px",
                  cursor: "pointer",
                }}
                src={gifImage}
                alt="/"
              ></img>
            </div> : null}
            <div
              className="s360-input-box-attachment"
              onClick={() => this.file.current.click()}
              
            >
              <input
                style={{ opacity: "0", width: "1px", display: "none" }}
                ref={this.file}
                type="file"
                multiple="multiple"
                onChange={this.onFileSelect}
                onKeyPress={this.handleKeyPress}
                className="UploadFile image_uploader"
              />
              {this.attachmentSVGImage(
                this.props.config.designDetails.innerButtonSVGColor
              )}
            </div>
            <div
              className="s360-input-box-setting"
              id="gif"
              style={{ marginBottom: "0px" }}
            >
              <img
                style={{
                  width: "24px",
                  height: "27px",
                  marginRight: "48px",
                  marginLeft: "2px",
                  cursor: "pointer",
                }}
                src={settingImage}
                alt="/"
                onClick={this.showSetting}
              ></img>

              <Modal
                show={this.state.showSetting}
                closeModal={() => this.setState({ showSetting: false })}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    fontSize: "13px",
                    cursor: "pointer",
                  }}
                >
                  <span style={{ marginBottom: "7px", color: "#687882" }}>
                    Press <span class="keyboard-key">Enter</span> to…
                  </span>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <label for="sendIt" className="modal-label">
                      <input
                        id="sendIt"
                        name="enter"
                        type="radio"
                        style={{ marginRight: "5px", cursor: "pointer" }}
                        onChange={this.handleRadio}
                        checked={this.state.radioValue === "sendIt"}
                      />
                      Send the message
                    </label>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <label for="newLine" className="modal-label">
                      <input
                        id="newLine"
                        name="enter"
                        type="radio"
                        style={{ marginRight: "5px", cursor: "pointer" }}
                        onChange={this.handleRadio}
                        checked={this.state.radioValue === "newLine"}
                      />
                      Start a new line
                    </label>
                  </div>
                </div>
              </Modal>
            </div>

            {this.state.previewFiles.length > 0 && (
              <PreviewAttachmentFiles
                {...this.props}
                {...this.state}
                onRemovePreviewFile={this.onRemovePreviewFile}
                files={this.state.previewFiles}
              />
            )}
          </div>
          <DefaultFooter {...this.props} />
        </div>
        <Snackbar
          open={this.state.showSnackBar}
          onClose={this.handleSnackbarClose}
          message={this.state.snackBarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          key={"bottom-right-snackbar"}
          autoHideDuration={3000}
        />
        {this.state.showSendChatTranscriptForm && (
          <SendChatTranscriptForm
            {...this.props}
            {...this.state}
            onSendChatTranscript={this.sendChatTranscript}
            onClose={() => {
              this.setState({ showSendChatTranscriptForm: false });
            }}
          />
        )}
        {this.state.showCloseDialog && (
          <AlertDialog
            {...this.props}
            {...this.state}
            handleAgree={this.closeConversation}
            handleDisagree={() => {
              this.setState({ showCloseDialog: false });
            }}
          />
        )}
      </div>
    );
  }

  handleRadio = (e) => {
    if (e.target.id == "sendIt") {
      this.setState({ radioValue: "sendIt" });
    } else {
      this.setState({ radioValue: "newLine" });
    }
  };

  handleSettingClose = () => {
    this.setState({ showSetting: false });
  };
  handleButtonClick = (event) => {
    this.setState({ showSetting: event.currentTarget });
  };

  onFileSelect = (e) => {
    if (e.target.files) {
      const filesToUpload = [];
      let files = e.target.files;
      for (var i = 0; i < files.length; i++) {
        filesToUpload.push(files[i]);
      }
      if (filesToUpload.length === 0) {
        return;
      }
      this.setState({ previewFiles: filesToUpload });
    }
  };
  onRemovePreviewFile = (file) => {
    let previewFiles = this.state.previewFiles || [];
    previewFiles = previewFiles.filter(
      (previewFile) => previewFile.name !== file.name
    );
    this.setState({ previewFiles: previewFiles });
  };

  onMessageSend = () => {
    console.log("emoji...");

    let isMediaAttached = (this.state.previewFiles || []).length !== 0;
    console.log("media", isMediaAttached);

    let hasTextMessage = !(
      !this.messageRef.current.value ||
      !this.messageRef.current.value.trim() ||
      this.messageRef.current.value === this.defaultMessage
    );
    console.log("txt...", hasTextMessage);
    if (!isMediaAttached && !hasTextMessage) {
      return;
    }
    if (hasTextMessage && !isMediaAttached) {
      console.log("emm", this.messageRef.current.value.trim());
      this.sendMessage(this.messageRef.current.value.trim());
    } else if (isMediaAttached) {
      console.log("emoji");
      let textMessage = hasTextMessage
        ? this.messageRef.current.value.trim()
        : null;
      this.setState({ isLoading: true }, () => {
        this.sendMessageWithAttachemnts(
          this.state.previewFiles,
          textMessage
        ).finally(() => {
          this.setState({ isLoading: false, previewFiles: [] });
        });
      });
    }
    this.messageRef.current.value = "";
    console.log("this.messageRef.current.value", this.messageRef.current.value);

    this.setState({ showEmoji: false });

    // document.getElementById('tx').style.height  = 34+"px";
    // document.getElementById('tx1').style.height = 24 +"px";
    // document.getElementById('img2').style.marginBottom = 0 + "px";
    // document.getElementById('emoji').style.marginBottom = 0 + "px";
    // document.getElementById('home').style.marginBottom = 0 + "px";
  };

  handleClose = () => {
    this.setState({ showGif: false });
  };

  showGIF = () => {
    let check = !this.state.showGif;
    this.setState({ showGif: check });
    if (this.state.showEmoji === true) {
      this.setState({ showEmoji: false });
    }
  };

  showSetting = () => {
    let check = !this.state.showSetting;
    this.setState({ showSetting: check });
    if (this.state.showEmoji === true) {
      this.setState({ showEmoji: false });
    }
  };

  onEmojiClick = (event, emojiObject) => {
    console.log(emojiObject, "here");
    const ref = this.messageRef.current;
    ref?.focus();

    const start = ref.value.substring(0, ref.selectionStart);
    const end = ref.value.substring(ref.selectionStart);
    console.log("stt", start, end);
    const txt = start + emojiObject.emoji + end;
    localStorage.setItem("txt", txt);
    ref.value = txt;
      // this.setState({
      //   finalvalue: ref.value,
      // });
      localStorage.setItem("finalvalue", ref.value);
    // this.setState({...this.state,showEmoji:true})
  };

  showEmoji = () => {
    console.log("123");
    let chk = this.state.showEmoji ? false : true;
    this.setState({ showEmoji: chk });
    if (chk == true && this.state.showGif === true) {
      this.setState({ showGif: false });
    }
  };

  attachmentSVGImage = (imageColor, width, height) => {
    // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    //     // width={width || "100%"} height={height || "100%"}
    //     viewBox="0 0 172 172"
    //     style={{ fill: imageColor }}><g transform="translate(-17.2,-17.2) scale(1.2,1.2)"><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M61.2965,154.06183c-11.11908,0 -22.24175,-4.2355 -30.702,-12.71008c-16.84883,-16.8775 -15.90642,-45.39008 0.95675,-62.25325l50.61817,-50.61817c5.96267,-5.96267 13.7815,-9.97242 22.19875,-10.49558c9.67142,-0.602 18.86625,2.88817 25.64233,9.67142c6.78325,6.77967 10.27342,15.9745 9.67142,25.64233c-0.52317,8.41367 -4.5365,16.23608 -10.49558,22.19875l-49.708,49.708c-4.00617,4.00617 -9.20558,6.79042 -14.84575,7.28492c-6.95167,0.60917 -13.588,-1.82033 -18.44342,-6.67933c-4.859,-4.85542 -7.2885,-11.49175 -6.67933,-18.44342c0.4945,-5.64017 3.27875,-10.84317 7.28492,-14.84575l34.64725,-34.64367c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-34.93033,34.93033c-1.85258,1.85258 -3.27158,4.17458 -3.73383,6.75458c-0.74533,4.14233 0.54108,8.17717 3.41492,11.051c4.66908,4.66908 12.80325,4.67625 17.48308,0l51.13775,-51.13775c4.24625,-4.257 6.58617,-9.90433 6.58617,-15.91358c0,-6.00925 -2.33992,-11.66017 -6.58975,-15.90642c-4.24983,-4.24625 -9.90075,-6.58975 -15.90642,-6.58975c-6.00567,0 -11.65658,2.33992 -15.90642,6.58975l-52.374,52.37042c-12.72083,12.72442 -12.72083,33.42533 0,46.14975c12.728,12.72083 33.42892,12.71725 46.14975,0l50.79733,-50.79733c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-50.79733,50.79733c-8.45308,8.45667 -19.565,12.685 -30.67692,12.685z"></path></g></g></g></svg>

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 18.241 20.804"
      >
        <g
          id="Icon-attachment"
          transform="translate(-201.85 -125.346)"
          opacity="0.85"
        >
          <path
            id="Icon-attachment-2"
            data-name="Icon-attachment"
            d="M16.226,8.477l-1.3-1.3-6.5,6.5a2.759,2.759,0,0,0,3.9,3.9l7.8-7.8a4.6,4.6,0,1,0-6.5-6.5L5.431,11.468l-.018.017a6.413,6.413,0,0,0,9.07,9.069l.016-.018h0l5.593-5.592-1.3-1.3L13.2,19.236l-.017.017a4.574,4.574,0,1,1-6.469-6.467l.018-.017h0l8.2-8.193a2.759,2.759,0,1,1,3.9,3.9l-7.8,7.8a.92.92,0,1,1-1.3-1.3l6.5-6.5Z"
            transform="translate(198.465 123.568)"
            fill="#4a6f8a"
          />
          <path
            id="Icon-attachment_-_Outline"
            data-name="Icon-attachment - Outline"
            d="M16.877,1.778a4.748,4.748,0,0,1,3.358,8.105l-7.8,7.8a2.909,2.909,0,1,1-4.114-4.114l6.61-6.608,1.513,1.512-6.61,6.609a.77.77,0,0,0,1.089,1.088l7.8-7.8a2.609,2.609,0,0,0-3.69-3.689l-8.1,8.1,0,0-.1.094-.014.013a4.424,4.424,0,0,0,6.257,6.255l.005-.005.014-.014,5.7-5.7,1.513,1.512L14.5,20.752h0a6.563,6.563,0,0,1-9.189-9.372l.012-.011,0,0,8.2-8.2A4.716,4.716,0,0,1,16.877,1.778Zm-6.5,16.46a2.593,2.593,0,0,0,1.845-.764l7.8-7.8a4.448,4.448,0,1,0-6.291-6.29L5.537,11.574l-.013.013,0,0a6.263,6.263,0,0,0,8.858,8.856l.016-.017.109-.111h0l5.378-5.377-1.089-1.088-5.506,5.5a4.724,4.724,0,0,1-6.754-6.6h0l.092-.094,8.2-8.193a2.909,2.909,0,1,1,4.114,4.113l-7.8,7.8a1.07,1.07,0,0,1-1.513-1.512l6.4-6.4L14.925,7.389l-6.4,6.4a2.608,2.608,0,0,0,1.845,4.453Z"
            transform="translate(198.465 123.568)"
            fill="#f4f8fc"
          />
        </g>
      </svg>
    );
  };

  emojiSVGImage = (imageColor, width, height) => {
    // return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
    //     // width={width || "100%"} height={height || "100%"}
    //     viewBox="0 0 172 172"
    //     style={{ fill: imageColor }}><g transform="translate(-17.2,-17.2) scale(1.2,1.2)"><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M61.2965,154.06183c-11.11908,0 -22.24175,-4.2355 -30.702,-12.71008c-16.84883,-16.8775 -15.90642,-45.39008 0.95675,-62.25325l50.61817,-50.61817c5.96267,-5.96267 13.7815,-9.97242 22.19875,-10.49558c9.67142,-0.602 18.86625,2.88817 25.64233,9.67142c6.78325,6.77967 10.27342,15.9745 9.67142,25.64233c-0.52317,8.41367 -4.5365,16.23608 -10.49558,22.19875l-49.708,49.708c-4.00617,4.00617 -9.20558,6.79042 -14.84575,7.28492c-6.95167,0.60917 -13.588,-1.82033 -18.44342,-6.67933c-4.859,-4.85542 -7.2885,-11.49175 -6.67933,-18.44342c0.4945,-5.64017 3.27875,-10.84317 7.28492,-14.84575l34.64725,-34.64367c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-34.93033,34.93033c-1.85258,1.85258 -3.27158,4.17458 -3.73383,6.75458c-0.74533,4.14233 0.54108,8.17717 3.41492,11.051c4.66908,4.66908 12.80325,4.67625 17.48308,0l51.13775,-51.13775c4.24625,-4.257 6.58617,-9.90433 6.58617,-15.91358c0,-6.00925 -2.33992,-11.66017 -6.58975,-15.90642c-4.24983,-4.24625 -9.90075,-6.58975 -15.90642,-6.58975c-6.00567,0 -11.65658,2.33992 -15.90642,6.58975l-52.374,52.37042c-12.72083,12.72442 -12.72083,33.42533 0,46.14975c12.728,12.72083 33.42892,12.71725 46.14975,0l50.79733,-50.79733c0.69875,-0.69875 1.83467,-0.69875 2.53342,0l5.06683,5.06683c0.69875,0.69875 0.69875,1.83467 0,2.53342l-50.79733,50.79733c-8.45308,8.45667 -19.565,12.685 -30.67692,12.685z"></path></g></g></g></svg>

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 22.341 22.341"
      >
        <g
          id="Icon_feather-smile"
          data-name="Icon feather-smile"
          transform="translate(0.75 0.75)"
          opacity="0.85"
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M13.421,24.591a11.171,11.171,0,0,1-7.9-19.069,11.171,11.171,0,1,1,15.8,15.8A11.1,11.1,0,0,1,13.421,24.591Zm0-20.841a9.671,9.671,0,1,0,9.671,9.671A9.682,9.682,0,0,0,13.421,3.75Z"
            transform="translate(-3 -3)"
            fill="#4a6f8a"
          />
          <path
            id="Path_2"
            data-name="Path 2"
            d="M16.168,23.834A6.361,6.361,0,0,1,11.4,21.45a.75.75,0,0,1,1.2-.9h0a4.915,4.915,0,0,0,3.57,1.787,4.852,4.852,0,0,0,3.568-1.784.75.75,0,0,1,1.2.9A6.361,6.361,0,0,1,16.168,23.834Z"
            transform="translate(-5.748 -8.495)"
            fill="#4a6f8a"
          />
          <path
            id="Path_3"
            data-name="Path 3"
            d="M13.51,15H13.5a1.5,1.5,0,0,1,0-3h.01a1.5,1.5,0,0,1,0,3Z"
            transform="translate(-6.206 -6.206)"
            fill="#4a6f8a"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M22.51,15H22.5a1.5,1.5,0,0,1,0-3h.01a1.5,1.5,0,0,1,0,3Z"
            transform="translate(-8.953 -6.206)"
            fill="#4a6f8a"
          />
        </g>
      </svg>
    );
  };

  onSendChatTranscriptClick = () => {
    this.setState({ showSendChatTranscriptForm: true });
  };

  sendChatTranscript = (emailId) => {
    this.setState({ showSendChatTranscriptForm: false });
    if (!emailId) {
      return;
    }
    xmppService.sendChatTranscript(this.props.activeConversation, emailId);
  };

  resetChat = () => {
    this.setState({ isReset: true }, () => {
      this.closeConversation();

      // this.startNewConversation();
    });
  };

  componentDidUpdate(prevProps, prevState) {
    console.log(
      "data...this.state.isConversationClose",
      this.state.isChatClose
    );
    console.log(
      "data...this.state.isConversationCloseed",
      this.state.isConversationClosed
    );
    if (prevState.isChatClose !== this.state.isChatClose) {
      console.log("data...working");
      this.startNewConversation();
    }
  }

  closeConversationClick = () => {
    this.setState({ showCloseDialog: true, open: true });
    //  let sessionId = this.props.activeConversation && this.props.activeConversation.sessionId;
    //  if (!sessionId) { return }
    //  xmppService.closeSession(sessionId).catch(error => { this.showSnackBarWithMessage("Could not close coversation, please try again.") });
  };

  closeConversation = () => {
    localStorage.removeItem("finalvalue");
    this.setState({
      showCloseDialog: false,
      open: false,
      isChatClose: !this.state.isChatClose,
    });
    let sessionId =
      this.props.activeConversation && this.props.activeConversation.sessionId;
    if (!sessionId) {
      return;
    }
    xmppService.closeSession(sessionId).catch((error) => {
      this.showSnackBarWithMessage(
        "Could not close coversation, please try again."
      );
    });
  };

  handleSnackbarClose = () => {
    this.setState({ showSnackBar: false });
  };

  showSnackBarWithMessage = (message) => {
    this.setState({ snackBarMessage: message, showSnackBar: true });
  };

  isActiveConversation = () => {
    let isClosed =
      (this.props.activeConversation &&
        this.props.activeConversation.active != null &&
        this.props.activeConversation.active !== undefined &&
        this.props.activeConversation.active === false) ||
      this.state.isConversationClosed;
    return !isClosed;
  };

  componentDidMount() {
    this.configure();
    console.log("conversation_page", this.props);

    // this.showSnackBarWithMessage("HI Welcome To Simplify360");
  }

  configure = () => {
    xmppService
      .configure(this.onXMPPMessage)
      .then(() => {
        this.fetchConversationHistory();
      })
      .then(() => {
        return this.startFetchingHealthPings();
      })
      .catch((error) => {
        //  console.log(error);
        HWLog.error(error, "Conversation: Component Did Mount: Error: ");
      });
  };

  componentWillUnmount() {
    this.removeHelathPingTimer();
  }

  isOnSameDay = (date, anotherDate) => {
    return (
      dayjs.unix(date).format("YY MMM DD") ===
      dayjs.unix(anotherDate).format("YY MMM DD")
    );
  };

  fetchConversationHistory = (lastFetchMessageId) => {
    let sessionInfo = this.props.activeConversation;
    console.log("inn", sessionInfo);
    console.log("lastFetch", lastFetchMessageId);
    // let messageHistory = (this.state.xmppMessageHistory || [])
    // let lastFetchMessageId = messageHistory[messageHistory.length - 1];
    return xmppService.fetchConversationHistory(
      sessionInfo,
      lastFetchMessageId,
      30
    );
  };

  onXMPPMessage = (message) => {
    if (!message) return;
    HWLog.info("CONVERSATION MESSAGE: ", message);
    //  To add more cases, add it in XMPPService class.
    switch (message.command) {
      case "HISTORY_RESPONSE":
        if (!this.state.isReset) this.parseMessageHistoryResponse(message);
        break;
      case "PING_RESPONSE":
        this.parseAgentStatusPingResponse(message);
        break;
      case "SESSION_CLOSE":
        if (!this.state.isReset) this.parseSessionCloseResponse(message);
        break;
      case "CHAT_STATUS":
        this.parseChatStatusResponse(message);
        break;
      case "BOT_REPLY":
        this.parseBotReplyResponse(message);
        break;
      case "AGENT_REPLY":
        this.parseAgentReplyResponse(message);
        break;
      case "TYPING_INDICATOR":
        this.parseTypingIndicatorResponse(message);
        break;
      case "SEND_CHAT_TRANSCRIPT_RESPONSE":
        this.parseChatTranscriptResponse(message);
        break;
      case "CREATE_SESSION":
        this.onCreateSessionResponse(message);
        break;
      default:
        break;
    }
  };

  parseMessageHistoryResponse = (message) => {
    console.log("mmm", message);
    HWLog.info("HISTORY_RESPONSE LIST MESSAGES", message);
    if (!message.listHistoryInfo || message.listHistoryInfo.length === 0) {
      this.setState({ isFetchingMessages: false });
      HWLog.info("EMPTY HiSTORY LIST");
      return;
    }
    let messagesToAdd = message.listHistoryInfo || [];
    messagesToAdd = messagesToAdd.map((i) => {
      i.id = i.id + "";
      let check = this.checkEmoji(i.message.text);
      if (i.convoType == "TEXT" && check) {
        i.convoType = "EMOJI";
      }
      return i;
    });
    this.addMessagesToList(messagesToAdd);
  };

  parseSessionCloseResponse = (message) => {
    console.log("cll");
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId === sessionId) {
      this.props.actions.markActiveConversationAsClosed();
      let sessionCloseMessage = this.getSessionCloseMessage();
      console.log("mss", sessionCloseMessage);
      this.addMessagesToList([sessionCloseMessage]);
    }
  };

  // Add Agent Transfer Ino Message.
  parseChatStatusResponse = (message) => {
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.warn("Invalid Chat Satus Session Id: ");
      return;
    }

    let firstName = (message.agentInfo && message.agentInfo.firstName) || "";
    let lastName = (message.agentInfo && message.agentInfo.lastName) || "";
    let showAgentInfo =
      this.props.config &&
      this.props.config.configDetails &&
      this.props.config.configDetails.showAgentInfo;
    if (!firstName.trim() || !lastName.trim() || !showAgentInfo) {
      return;
    }
    let agentName = (firstName + " " + lastName).trim();

    let messageToShow = "You are transferred to agent " + agentName;
    let messageTime = new Date();
    let chatInfoMessage = {
      message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
      id: "agent-info-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "CLOSE",
      syntheticMessage: true,
    };
    this.addMessagesToList([chatInfoMessage]);
    var headerVal = document.getElementsByClassName(
      "s360-conversation-header-details-title"
    );

    for (var i = 0; i < headerVal.length; i++) {
      headerVal[i].innerHTML = agentName;
    }
    let agentDisplayInitials =
      message.agentInfo &&
      message.agentInfo.firstName &&
      message.agentInfo.lastName
        ? message.agentInfo.firstName.charAt(0) +
          "" +
          message.agentInfo.lastName.charAt(0)
        : "B";
    document.getElementById("headerImgDiv").innerHTML = agentDisplayInitials;
  };

  parseBotReplyResponse = (message) => {
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For BOT REPLY: ", message || {});
      return;
    }
    if (!message.id) {
      message.id = uuid();
    }
    message.id = message.id + "";
    this.addMessagesToList([message]);
    if (this.props.config.notification.isEnabled) this.audio.play();
  };

  parseAgentReplyResponse = (message) => {
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For AGENT REPLY: ", message || {});
      return;
    }
    if (!message.id) {
      message.id = uuid();
    }
    message.id = message.id + "";
    message.creator = "AGENT";
    this.addMessagesToList([message]);
    if (this.props.config.notification.isEnabled) this.audio.play();
  };

  parseTypingIndicatorResponse = (message) => {
    let isTyping = message.typing || false;
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For Typing Indicator: ", message || {});
      return;
    }
    this.setState({ isTyping: isTyping });
    //  console.log("Agent Typing....: " + isTyping);
  };

  parseChatTranscriptResponse = (messageData) => {
    // let title = "Success!";
    let message = "The transcript is sent to your preferred Email ID";
    // alert(title + message);
    this.props.actions.showPopUpMessage(message);
  };

  addMessagesToList = (messagesToAdd) => {
    console.log("messageToAdd", messagesToAdd);
    if (!messagesToAdd || messagesToAdd.length === 0) {
      return;
    }
    let messages = this.state.messages || [];
    let messageIds = messages.map((i) => i.id);
    let newMessages = messagesToAdd.filter(
      (i) => messageIds.indexOf(i.id) === -1
    );
    let sortedMessagesList = [...messages, ...newMessages].sort(
      (a, b) => a.message.sentTimestamp - b.message.sentTimestamp
    );
    let parsedMessages = this.parseMessagesForTimeStamps(sortedMessagesList);
    let canScrollToLatestMessage = this.state.isFetchingMessages !== true;
    this.setState(
      { messages: parsedMessages, isFetchingMessages: false },
      () => {
        if (canScrollToLatestMessage) {
          this.conversationRef.current.scrollToLatestMessage();
        } else {
          this.conversationRef.current.scrollToLastPosition();
        }
      }
    );
  };

  parseMessagesForTimeStamps = (messagesList) => {
    let messageList = [];
    let datePointer = null;
    let messages = messagesList.filter((i) => !i.syntheticDateInfoMessage); // Filter out synthetic date info messages.
    let messageIds = messages.map((i) => i.id);
    messages.forEach((message, index) => {
      if (message.id === "session-close-message") {
        return;
      } // Filter out session close message.
      if (
        !(
          datePointer &&
          this.isOnSameDay(datePointer, message.message.sentTimestamp / 1000)
        )
      ) {
        let messageDateTimeText = dayjs
          .unix(message.message.sentTimestamp / 1000)
          .format("DD MMM YYYY");
        if (messageIds.indexOf(messageDateTimeText) === -1) {
          // Add synthetic date info message.
          messageList.push({
            message: {
              text: messageDateTimeText,
              sentTimestamp: message.message.sentTimestamp,
            },
            id: messageDateTimeText,
            type: MessageType.info,
            timestamp: message.message.sentTimestamp,
            syntheticMessage: true,
            syntheticDateInfoMessage: true,
          });
          datePointer = message.message.sentTimestamp / 1000;
        }
      }
      message.type = this.parseMessageType(message.creator);
      messageList.push(message);
    });
    if (!this.isActiveConversation()) {
      // Add session close message, if current session is closed.
      let sessionCloseMessage = this.getSessionCloseMessage();
      if (sessionCloseMessage) {
        messageList.push(sessionCloseMessage);
      }
    }
    return messageList;
  };

  parseMessageType = (creator) => {
    if (creator === "CUSTOMER") {
      return MessageType.sent;
    } else if (creator === "BOT" || creator === "AGENT") {
      return MessageType.received;
    } else {
      return MessageType.info;
    }
  };

  // MARK : New Ccnversation
  doMoveToNewConversation = false;
  startNewConversation = () => {
    this.doMoveToNewConversation = true;
    xmppService.createSession().catch((error) => {
      HWLog.error(error, "New Conversation Error: ");
      this.doMoveToNewConversation = false;
      return error;
    });
  };

  onCreateSessionResponse = (newSessionResponse) => {
    if (this.doMoveToNewConversation) {
      this.props.actions.startConversation(newSessionResponse, () => {
        this.setState(
          {
            messages: [],
            xmppMessageHistory: [],
            isConversationClosed: false,
            showSnackBar: false,
            showSendChatTranscriptForm: false,
          },
          () => {
            this.configure();
          }
        );
      });
    }
  };

  // MARK: AGENT HEALTH PING:
  // Start fetching health ping for every 10 seconds. Stop heath ping time on component unmount.

  agentHealthPingTimerId = null;

  // startFetchingHealthPings = () => {
  //     if (!this.isActiveConversation()) { return }
  //     let sessionId = this.props.activeConversation.sessionId;
  //     if (!sessionId) { HWLog.warn("No Session Id Available To Fetch Agent Health Ping: "); return; }
  //     xmppService.fetchAgentHealthPing(sessionId);
  //     this.agentHealthPingTimerId = setInterval(async () => {
  //         xmppService.fetchAgentHealthPing(sessionId);
  //     }, 10000)
  // }

  removeHelathPingTimer = () => {
    if (this.agentHealthPingTimerId) {
      clearInterval(this.agentHealthPingTimerId);
    }
  };

  //  GREEN - Online
  //  RED - Offline
  //  Yellow - Away
  parseAgentStatusPingResponse = (message) => {
    let sessionId = message.sessionId || "";
    let activeSessionInfo = this.props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info(
        "Invalid Session Id: For Agant Health Ping Response: ",
        message || {}
      );
      return;
    }
    let status = (message.onlineStatus && message.onlineStatus.status) || "";
    let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
    if (!isValidStatus) {
      HWLog.info("Invlaid Ping Status From Server: ", message || {});
      return;
    }
    HWLog.info("AGENT PING STATUS: " + status);
    this.setState({ agentPingStatus: status });
  };

  // MARK: Actions
  actions = {
    sendMessage: (message) => this.sendMessage(message),
    sendMessageWithAttachemnts: (files, textMessage) =>
      this.sendMessageWithAttachemnts(files, textMessage),
    sendTypingStatus: (typing) => this.sendTypingStatus(typing),
    sendMessageWithCode: (textMessage, dispalyMessage) =>
      this.sendMessageWithCode(textMessage, dispalyMessage),
  };

  sendTypingStatus = (typing) => {
    let sessionId =
      this.props.activeConversation && this.props.activeConversation.sessionId;
    if (!sessionId) {
      return;
    }
    HWLog.info("TYPING STATUS CHANGE: " + typing);
    xmppService.sendTypingIndicatorStatus(sessionId, typing).catch((error) => {
      HWLog.error(error, "Could not send typing status.");
    });
  };

  checkEmoji = (textMessage) => {
    if (!textMessage) return;
    const regexpEmojiPresentation = /\p{Emoji_Presentation}/gu;
    const regex =
      /([\p{Alphabetic}\p{Mark}\p{Decimal_Number}\p{Connector_Punctuation}\p{Join_Control}]+)/gu;
    const special_char = /[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g;

    console.log("tw", textMessage);

    if (
      textMessage.match(regexpEmojiPresentation) != null &&
      textMessage.match(regexpEmojiPresentation).length == 1
    ) {
      if (
        textMessage.match(regex) == null &&
        textMessage.match(special_char) == null
      ) {
        return true;
      }
    }
    return false;
  };

  sendMessage = (textMessage) => {
    //    this.parseTypingIndicatorResponse({"configId":710,"sessionId":this.props.activeConversation.sessionId,"command":"TYPING_INDICATOR","typer":"AGENT","typing":true,"fromUi":false,"sourceType":0,"isJabber":false,"fromApi":false});
    //    console.log("data..em",textMessage.type)
    let check = this.checkEmoji(textMessage);
    let type = "TEXT";
    if (check) {
      this.setState({ isOnlyEmoji: true });
      type = "EMOJI";
    } else {
      this.setState({ isOnlyEmoji: false });
    }

    let messageTime = new Date();
    let newMessageToSend = {
      message: { text: textMessage, sentTimestamp: messageTime.getTime() },
      id: uuid(),
      type: MessageType.sent,
      timestamp: messageTime.getTime(),
      convoType: type,
      creator: "CUSTOMER",
      syntheticMessage: true,
    };
    // let newMessageToSend = { message: { text: textMessage }, id: uuid(), type: MessageType.received, timestamp: messageTime.getTime(), convoType: "TEXT", creator: "BOT", syntheticMessage: true }
    let sessionInfo = this.props.activeConversation;
    let message = { text: textMessage, sentTimestamp: messageTime.getTime() };
    //       let message = { text: textMessage, sentTimestamp: messageTime.getTime() }
    xmppService
      .sendMessage(sessionInfo.sessionId, message, "TEXT")
      .then((result) => {
        this.addMessagesToList([newMessageToSend]);
      })
      .catch((error) => {
        console.log("Could Not Send Message");
      });
  };

  sendMessageWithAttachemnts = (attachedFiles, textMessage) => {
    console.log("qpp");
    let sessionInfo = this.props.activeConversation;
    let messageAttachments = [];
    let fileUploadTasks = attachedFiles.map((file) => {
      let fileType = this.parseFileTypeToSend(file);
      console.log("fileType", fileType);
      return apiService.uploadMedia(file, fileType, sessionInfo.sessionId).then(
        (result) => {
          console.log("result", result);
          let date = new Date();
          let mediaMessage = {
            message: { text: result.data.url, sentTimestamp: date.getTime() },
            id: uuid(),
            type: MessageType.sent,
            timestamp: date.getTime(),
            convoType: fileType.toUpperCase(),
            creator: "CUSTOMER",
            syntheticMessage: true,
          };
          messageAttachments.push(mediaMessage);
          return result;
        },
        (result) => {
          console.log("err", result.response);
        }
      );
    });
    return Promise.all(fileUploadTasks)
      .then((result) => {
        if (textMessage && textMessage.trim()) {
          let messageTime = new Date();
          let newMessageToSend = {
            message: {
              text: textMessage,
              sentTimestamp: messageTime.getTime(),
            },
            id: uuid(),
            type: MessageType.sent,
            timestamp: messageTime.getTime(),
            convoType: "TEXT",
            creator: "CUSTOMER",
            syntheticMessage: true,
          };
          messageAttachments.push(newMessageToSend);
        }
        let sendMessageTasks = messageAttachments.map((messageItem) => {
          let message = {
            text: messageItem.message.text,
            sentTimestamp: messageItem.message.sentTimestamp,
          };
          let convoType = messageItem.convoType;
          return xmppService
            .sendMessage(sessionInfo.sessionId, message, convoType)
            .then((result) => {
              this.addMessagesToList([messageItem]);
            });
        });
        return Promise.all(sendMessageTasks);
        //.catch(error => { alert("Could Not Send Message"); });
      })
      .catch((error) => {
        console.log("Could Not Send Message");
      });
  };

  parseFileTypeToSend = (file) => {
    if (file.type.toLowerCase().indexOf("audio") !== -1) {
      return "audio";
    } else if (file.type.toLowerCase().indexOf("video") !== -1) {
      return "video";
    } else if (file.type.toLowerCase().indexOf("image") !== -1) {
      return "image";
    } else {
      return "document";
    }
  };

  getSessionCloseMessage = () => {
    let sessionCloseMessage =
      this.props.config &&
      this.props.config.configDetails &&
      this.props.config.configDetails.sessionCloseMessage;
    if (!sessionCloseMessage) {
      HWLog.warn("Session Close Message Not Available In Config:");
      return null;
    }
    let messageTime = new Date();
    let sessionCloseMessageToAdd = {
      message: {
        text: sessionCloseMessage,
        sentTimestamp: messageTime.getTime(),
      },
      id: "session-close-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "CLOSE",
      syntheticMessage: true,
    };
    return sessionCloseMessageToAdd;
  };

  // MARK: Handle Conversation Messages Pagination
  onScrollToConversationTop = () => {
    HWLog.info("SCROLLED TO TOP:");
    this.fetchPreviousPageMessages();
  };

  fetchPreviousPageMessages = () => {
    if (this.state.isFetchingMessages) {
      return;
    }
    let messageHistory = (this.state.messages || []).filter(
      (i) => !i.syntheticMessage
    );
    if (messageHistory.length === 0) {
      return;
    }
    let lastFetchMessage = messageHistory[0];
    if (!lastFetchMessage || !lastFetchMessage.id) {
      return;
    }
    this.setState({ isFetchingMessages: true }, () => {
      this.fetchConversationHistory(lastFetchMessage.id).catch((error) => {
        this.setState({ isFetchingMessages: false });
      });
    });
  };

  // MARK:  Style Functions
  conversationStyle = () => {
    // let config = this.props.config;
    return {
      // height: "7%"
    }; //{backgroundColor: config.designDetails.pageBackgroundColor}
  };

  containerStyle = () => {
    let config = this.props.config;
    let height = window.screen.height * 0.75;
    // let height = window.screen.height * 0.34;
    return {
      backgroundColor: config.designDetails.pageBackgroundColor,
      height: "100%",
      backgroundImage :config?.designDetails?.conversationBackground&&config?.designDetails.conversationBackground!== "" ? `url(${config?.designDetails?.conversationBackground&&config?.designDetails.conversationBackground})` :config.designDetails.pageBackgroundColor,
    };
  };

  sendMessageWithCode = (textMessage, dispalyMessage) => {
    //    this.parseTypingIndicatorResponse({"configId":710,"sessionId":this.props.activeConversation.sessionId,"command":"TYPING_INDICATOR","typer":"AGENT","typing":true,"fromUi":false,"sourceType":0,"isJabber":false,"fromApi":false});
    let messageTime = new Date();
    let newMessageToSend = {
      message: { text: dispalyMessage, sentTimestamp: messageTime.getTime() },
      id: uuid(),
      type: MessageType.sent,
      timestamp: messageTime.getTime(),
      convoType: "TEXT",
      creator: "CUSTOMER",
      syntheticMessage: true,
    };
    let sessionInfo = this.props.activeConversation;
    let message = { text: textMessage, sentTimestamp: messageTime.getTime() };
    xmppService
      .sendMessage(sessionInfo.sessionId, message, "TEXT")
      .then((result) => {
        this.addMessagesToList([newMessageToSend]);
      })
      .catch((error) => {
        console.log("Could Not Send Message");
      });
  };
}

export default ConversationPage;
